import { getFromEnvironment, getIsLocal } from 'ComponentLibrary/src/common/environment'
import invariant from 'tiny-invariant'

export function getAppraiserUIBaseUrl(): string {
    return getFromEnvironment('VITE_APPRAISER_UI_BASE_URL', 'https://appraiser.einwert.com')
}

export function getExternalDataroomBaseUrl(): string {
    const isLocal = getIsLocal()
    const baseUrl = getFromEnvironment('VITE_EXTERNAL_DATAROOM_BASE_URL', isLocal ? window.location.origin : undefined)
    if (!isLocal) {
        invariant(new URL(baseUrl).protocol === 'https:', 'VITE_EXTERNAL_DATAROOM_BASE_URL must be an absolute HTTPS URL.')
    }
    return baseUrl
}

export function getIsDatadogEnabled(): boolean {
    return getFromEnvironment('VITE_DATADOG_ENABLED', 'false') === 'true'
}
